<template>
    <Modal modalType="savedVehicle" :removePadding="true" :narrow="false" :open="showSavedVehicleModal === 1" :show-close-icon="true" @close="dismissModal" :is-card="true" :close-has-background="true">
        <template v-slot:image>
            <div class="saved-vehicle__image-wrapper">
                <picture>
                    <source
                        srcset="/images/my-account/saved-vehicles/modal-image@1x.webp 1x, /images/my-account/saved-vehicles/modal-image@2x.webp 2x"
                        type="image/webp"
                    />
                    <img
                        class="saved-vehicle__image"
                        srcset="/images/my-account/saved-vehicles/modal-image@1x.jpg 1x, /images/my-account/saved-vehicles/modal-image@2x.jpg 2x"
                    />
                </picture>
            </div>
        </template>
        <LoadingSpinner v-if="loading" />
        <div class="saved-vehicle__container">
            <div class="saved-vehicle__body">
                <div class="saved-vehicle__body-item">
                    <h1 class="saved-vehicle__body-h1">This Vehicle Has Been <br>
                        Saved To Your Account
                    </h1>
                </div>
                <div class="saved-vehicle__body-item">
                    <p class="saved-vehicle__subheading">To view this vehicle in your account please click the button below or continue your search.</p>
                </div>
                <div class="saved-vehicle__body-item">
                    <a v-if="!loading" href="/my-account/saved-vehicles" type="button" class="btn btn--primary btn--full-width">VIEW SAVED VEHICLES</a>
                </div>
                <div v-if="!loading" class="saved-vehicle__body-item">
                <template v-if="lastSearchPage">
                    <a href="" @click.prevent="backToSearch" class="link link--secondary link--has-icon-reverse link--centered ">Back To Search</a>
                </template>
                <template v-else>
                    <a v-if="!loading" @keypress.enter="dismissModal" @click="dismissModal" class="link link--secondary link--has-icon-reverse link--centered">BACK TO SEARCH</a>
                </template>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script>
import LoadingSpinner from "../../core/components/Modal.vue";
import Modal from "../../core/components/Modal.vue";
import { mapState } from 'vuex';

export default {
    components: {
        LoadingSpinner,
        Modal,
    },
    props: {
        'lastSearchPage': {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            loading: false,
        };
    },

    computed: {
        ...mapState("Layout", [
            'showSavedVehicleModal',
        ]),
    },

    methods: {
        dismissModal() {
            this.$store.commit("Layout/setShowSavedVehicleModal", 1);
        },
        backToSearch(){
            this.$store.commit("Layout/setShowSavedVehicleModal", 1);
            this.$router.push(this.lastSearchPage)
        }
    },
};
</script>

<style lang="scss">
  @import "../../../sass/used/search-results/saved-vehicle-modal";
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/SavedVehicleModal.vue